var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('input',_vm._g(_vm._b({ref:"input",domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }